import React, { useState, useContext } from 'react';
import ButtonPrimary from '../../components/buttons/ButtonPrimary';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthContext from '../../contexts/AuthContext';
import AuthService from '../../services/AuthService';

const LoginForm = ({ onToggleRegister }) => {
    const navigate = useNavigate();
    const [showRegister, setShowRegister] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);

    const auth = useContext(AuthContext);

    const emptyField = () => {
        setPassword("");
        setEmail("");
    };

    const handleLoginSubmit = async (event) => {
        event.preventDefault();

        try {
            const response = await fetch('/api/auth/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password, rememberMe }) // Include Remember Me checkbox value
            });

            const data = await response.json();

            if (response.status === 200) {
                AuthService.setUserSession(data.user);
                auth.setUser(data.user);
                navigate('/home');
            } else {
                toast.error(data.message || 'An error occurred');
                emptyField();
            }
        } catch (error) {
            toast.error(error.message || 'An error occurred');
            emptyField();
        }
    };

    const handleRememberMeChange = (event) => {
        setRememberMe(event.target.checked);
    };

    const handleGoogleLogin = () => {
        // Open a new window for Google OAuth login
        window.open('/api/auth/google', '_self');
    };

    const handleFacebookLogin = () => {
        // Open a new window for Facebook OAuth login
        window.open('/api/auth/facebook', '_self');
    };

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    };

    const handleToggleRegister = () => {
        onToggleRegister();
    };

    const handleForgotPassword = () => {
        navigate('/forgotpassword'); 
    };

    return (
        <>
            <form id="login-form" className={showRegister ? 'hide' : 'show'} onSubmit={handleLoginSubmit}>
                <div className="row">
                    <div className="col-12">
                        <span id="login-title">Login</span>
                    </div>
                </div>
                <div className="row margin-btm-30">
                    <div className="col-12">
                        <span className="icon textbox-icon-container">
                            <ion-icon name="mail">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="icon icon-tabler icon-tabler-mail"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1"
                                    stroke="#000000"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <rect x="3" y="5" width="18" height="14" rx="2" />
                                    <polyline points="3 7 12 13 21 7" />
                                </svg>
                            </ion-icon>
                        </span>
                        <input
                            className="form-control fillet-text-box text-box-with-icon"
                            type="text"
                            placeholder="Email"
                            name="email"
                            value={email}
                            onChange={handleEmailChange}
                            required
                        />
                    </div>
                </div>
                <div className="row margin-btm-15">
                    <div className="col-12">
                        <span className="icon textbox-icon-container">
                            <ion-icon name="loc-closed">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="icon icon-tabler icon-tabler-eye"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1"
                                    stroke="#000000"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <circle cx="12" cy="12" r="2" />
                                    <path d="M22 12c-2.667 4.667 -6 7 -10 7s-7.333 -2.333 -10 -7c2.667 -4.667 6 -7 10 -7s7.333 2.333 10 7" />
                                </svg>
                            </ion-icon>
                        </span>
                        <input
                            className="form-control fillet-text-box text-box-with-icon"
                            type="password"
                            placeholder="Password"
                            name="password"
                            value={password}
                            onChange={handlePasswordChange}
                            required
                        />
                    </div>
                </div>
                <div className="row margin-btm-15">
                    <div className="col align-left no-wrap">
                        <label>
                            <input
                                type="checkbox"
                                checked={rememberMe}
                                onChange={handleRememberMeChange}
                            />
                            Remember me
                        </label>
                    </div>
                    <div className="col align-right no-wrap">
                        <div className="col align-right no-wrap">
                            <span role="button" onClick={handleForgotPassword}>
                                <u>Forgot password?</u>
                            </span>
                        </div>
                    </div>
                </div>

                <ButtonPrimary className="margin-btm-15" type="submit" value="Login" />

                <div className="row margin-btm-15">
                    <div className="col-12">
                        <span>
                            Don't have an account?{" "}
                            <span className="bold signup-toggle-btn" onClick={handleToggleRegister}>
                                Register
                            </span>
                        </span>
                    </div>
                </div>

                {/*<div className="row margin-btm-15">*/}
                {/*    <div className="col-12">*/}
                {/*        <span className="back-line">or</span>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/*<div className="row">*/}
                {/*    <div className="col-6">*/}
                {/*        <ButtonPrimary type="submit" value="Facebook" onClick={handleFacebookLogin} />*/}
                {/*    </div>*/}
                {/*    <div className="col-6">*/}
                {/*         <ButtonPrimary type="submit" value="Google" onClick={handleGoogleLogin} />*/}
                {/*    </div>*/}
                {/*</div>*/}
            </form>
        </>
    );
};

export default LoginForm;
